import React from 'react';
import './NotFound.css';
import Lottie from 'react-lottie';
import animationData from '../../animations/zenPerson.json';

export default function Zen() {
  const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }
    };
  
  return (
    <div>
      <Lottie 
	    options={defaultOptions}
        height={400}
        width={400}
      />
    </div>
  );
}